import { Star, Quote } from "lucide-react";
import { REVIEWS } from "../data";
import { Reveal } from "./Reveal";

export const Reviews = () => (
  <section id="reviews" data-testid="reviews-section" className="py-24 md:py-32 bg-surface">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <p className="eyebrow text-gold mb-4">Reviews</p>
        <h2 className="font-heading font-light text-4xl sm:text-5xl tracking-tight leading-none max-w-2xl">
          What clients say
        </h2>
        <p className="text-[#52525b] font-light text-lg mt-6 max-w-xl">
          Real results, real relationships. Here's what buyers and sellers across Southern California
          say about working with Melissa.
        </p>
      </Reveal>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-16">
        {REVIEWS.map((r, i) => (
          <Reveal key={r.name} delay={i * 0.08}>
            <figure data-testid={`review-${i}`} className="bg-white border border-black/5 p-8 h-full flex flex-col hover:-translate-y-1 hover:shadow-lg transition-all duration-300">
              <Quote className="text-gold" size={26} />
              <blockquote className="text-[#0a0a0a] font-light leading-relaxed mt-5 flex-1">
                "{r.text}"
              </blockquote>
              <div className="flex items-center gap-1 mt-6">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} size={15} className="text-gold fill-gold" />
                ))}
              </div>
              <figcaption className="mt-4 pt-4 border-t border-black/5">
                <p className="font-heading text-lg">{r.name}</p>
                <p className="eyebrow text-[10px] text-[#a1a1aa] mt-1">{r.location}</p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
